import { render, staticRenderFns } from "./zhHantPrivacy.vue?vue&type=template&id=020c71b2&scoped=true&"
import script from "./zhHantPrivacy.vue?vue&type=script&lang=js&"
export * from "./zhHantPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./zhHantPrivacy.vue?vue&type=style&index=0&id=020c71b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020c71b2",
  null
  
)

export default component.exports